import PropTypes from 'prop-types'
import React from 'react'
import ClassNames from 'classnames'
import moment from 'moment'

class CameraChart extends React.PureComponent {
  static propTypes = {
    historicalCameraData: PropTypes.object.isRequired,
    xStart: PropTypes.string.isRequired,
    xEnd: PropTypes.string.isRequired,
    className: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string)
    ])
  }

  render () {
    const {
      historicalCameraData
    } = this.props

    const videoStyle = {
      paddingLeft: '10px',
      paddingRight: '10px',
      marginLeft: '5px',
      marginRight: '5px'
    }
    const className = ClassNames('camera-chart', this.props.className)
    return (
      <div className={className} style={{overflowX: 'auto', whiteSpace: 'nowrap'}}>
        {historicalCameraData.data ? (
          <div>
            {historicalCameraData.data.length > 0 ? (
              historicalCameraData.data.map(timeLapse => {
                return (
                  <div key={timeLapse.objectId} style={{display: 'inline-block'}}>
                    <video style={videoStyle} width="300" height="200" controls allowFullScreen poster={timeLapse.thumbnailUrl}>
                      <source src={timeLapse.url} type="video/mp4" />
                    </video>
                    <p style={{textAlign: 'center'}}>{moment(timeLapse.startedAt).format('MMM Do hA')} - {moment(timeLapse.startedAt).add(12, 'hours').format('MMM Do hA')}</p>
                  </div>
                )
              })
            ) : (
              <p>No time lapses for given time period.</p>
            )}
          </div>
        ) : null}
      </div>
    )
  }
}

export default CameraChart



// WEBPACK FOOTER //
// /Users/alextaxiera/source/farmhand-server/client/dashboard/src/js/components/camera-chart/index.js